<template>
  <div>
    <v-menu lazy :close-on-content-click="false" v-model="menu" transition="scale-transition" offset-y max-width="290px" min-width="290px">
      <v-text-field slot="activator" :label="'Date (yyyy-mm-dd HH:MM)'" v-model="datetimeText" @input="onTextInput" :mask="mask" :error="!datetimeParsed.isValid && datetimeText.length > 0" :hint="!datetimeParsed.isValid ? errorTextInvalidDate : formatDateFromMoment(datetimeParsed.parsedMoment, 'MMM DD, YYYY LT')" persistent-hint prepend-icon="event"></v-text-field>
      <v-window v-model="stage" vertical>
        <v-window-item :key="0">
          <v-date-picker no-title full-width scrollable :min="minDateBound" :max="maxDateBound" :value="datePickerText" @input="onDateSelected"></v-date-picker>
        </v-window-item>
        <v-window-item :key="1">
          <!-- v-time-picker title is used for choosing AM/PM -->
          <v-time-picker full-width scrollable :value="timePickerText" @input="onTimeSelected" @click:minute="onTimeClose"></v-time-picker>
        </v-window-item>
      </v-window>
    </v-menu>
  </div>
</template>

<script>
  import MomentUtil from './mixins/MomentUtil'
  import moment from 'moment'
  const datetimeFormat = 'YYYY-MM-DD HH:mm'
  const datetimeMask = '####-##-## ##:##'
  export default {
    mixins: [MomentUtil],
    props: {
      direction: {
        type: String,
        default: 'bottom',
      },
      minDateBound: {
        type: String, // YYYY-MM-DD
        default: '',
      },
      maxDateBound: {
        type: String, // YYYY-MM-DD
        default: '',
      },
      triggerReset: {
        // toggle between 0 and 1 to trigger date pickers to reset to auto date range.
        type: Number,
        default: 0,
      },
      resetDateRangeOption: {
        // string option found in preset-buttons e.g. 'Most recent two weeks'
        type: String,
        default: '',
      },
      utcOffsetMinutes: {
        type: Number,
        default: 0,
      },
      calendarMark: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        menu: false,
        datetime: '',
        datetimeText: '',
        stage: 0,
        datePickerText: '',
        timePickerText: '',
        datetimeParsed: {},
        errorTextInvalidDate: 'Enter a valid date',
      }
    },
    computed: {
      mask() {
        return datetimeMask
      },
    },
    methods: {
      showTimePicker() {
        this.stage = 1
      },
      clearPicker() {
        this.stage = 0
        this.menu = false
      },
      emitInputEvent() {
        let datetimeParsed = JSON.parse(JSON.stringify(this.datetimeParsed))
        datetimeParsed.parsedMoment = moment
          .utc(datetimeParsed.parsedMoment)
          .utcOffset(this.utcOffsetMinutes, true)
        datetimeParsed.parsedDate = datetimeParsed.parsedMoment.toDate()
        this.$emit('input', datetimeParsed)
      },
      onDateSelected(dateText) {
        this.showTimePicker()
        this.datePickerText = dateText
      },
      onTimeSelected(timeText) {
        this.timeText = timeText
        let datetimeText = `${this.datePickerText} ${timeText}`
        this.datetimeText = this.parseDatetime(datetimeText)
      },
      onTimeClose() {
        this.clearPicker()
      },
      onTextInput(datetimeText) {
        this.parseDatetime(datetimeText)
      },
      setDateMark(date) {
        //component return date is string
        if (this.calendarMark.includes(date)) {
          return true
        } else {
          return false
        }
      },
      parseDatetime(datetimeText) {
        let parsed = this.parseDateTextToMoment(datetimeText, {
          format: datetimeFormat,
        })
        this.datetimeParsed = parsed
        if (parsed.isValid) {
          this.datetime = this.formatDateFromMoment(
            parsed.parsedMoment,
            datetimeFormat
          )
        } else {
          this.datetime = null
        }
        this.emitInputEvent()
        return this.datetime
      },
    },
  }
</script>

<style lang="stylus" scoped></style>